import { instance } from '../../util/http'
import apis from '../../config/apis'

const get = (goodsCode) => {
    return instance.get(apis.Goods.Get + "?goodsid=" + goodsCode )
}
// 添加购物车
const addBasket = (postData) => {
    return instance.post(apis.Goods.AddBasket, {
        goodsId: postData.goodsId,
        goodsName: postData.goodsName,
        costPrice: postData.costPrice,
        retailPrice: postData.retailPrice,
        quantity: postData.quantity,
        pictureUrl: postData.pictureUrl,
        specificationNames: postData.specificationNames,
        skuId:postData.skuId,
        skuCode:postData.skuCode,
        SkuCodeNo:postData.skuNo,
        checked:true
    })
}
const getByName = (Search,page,pageSize) => {
    return instance.get(apis.Goods.GetByName + "?name=" + Search + "&page=" + page + "&limit=" + pageSize)
}

const getGoodsMarketing = (id, shareId) => {
    return instance.get(apis.Goods.Marketing + "?goodsId=" + id + "&shareId=" + shareId)
}

const getGoodsCoupon = (goodsCode) => {
    return instance.get(apis.Goods.Coupon + "?goodsCode=" + goodsCode)
}
// 获取限购商品详情
const GetLimitGoodsDetail = (data) => {
    return instance.post(apis.Goods.GetLimitGoodsDetail,data)
}
// 获取分享图片 /api/v1/goods-module/goods-img
const getsharePicture = (goodsId) => {
    return instance.get(apis.Goods.GetSharePicture + "?goodsId=" + goodsId)
}
// 获取分享图片 /api/v1/goods-module/goods-img
const getUserImg = (userid) => {
    return instance.get(apis.Goods.GetUserImg + "?userid=" + userid)
}

// 获取购物车列表
const getCart = () => {
    return instance.get(apis.Cart.Get);
}
export default {
    get,
    addBasket,
    getByName,
    getGoodsMarketing,
    getGoodsCoupon,
    GetLimitGoodsDetail,
    getCart,
    getsharePicture,
    getUserImg
}